import he from 'he';
import AuthenticatedController from './AuthenticatedController';
import FBPostModel from '../model/FBPostModel';

import * as APIRoutes from '@mm/api-routes';

const normalizedPost = (post: FBPostModel): FBPostModel =>
  Object.assign(post, {
    message: he.decode(post.message || ''),
  });

class FBPostController extends AuthenticatedController {
  static async getAll(pageId: number): Promise<FBPostModel[]> {
    const response = await super.get(`${APIRoutes.FBPosts(pageId)}`);
    return response.posts.map((post: FBPostModel) => normalizedPost(post));
  }

  static async getRecommended(pageId: number): Promise<FBPostModel[]> {
    const response = await super.get(
      `${APIRoutes.FBPosts(pageId)}/recommended`,
    );

    return response.recommendedPosts.map((post: FBPostModel) =>
      normalizedPost(post),
    );
  }

  static async getById(pageId: number, postId: number): Promise<FBPostModel> {
    const response = await super.get(`${APIRoutes.FBPosts(pageId)}/${postId}`);
    return normalizedPost(response.post);
  }
}

export default FBPostController;
